import { type TableColumnSpec } from "#blocks/Table/buildTableColumns"
import { MakeupForTable } from "#customTypes/composedTypes/makeupTypes"

export const MAKEUP_TABLE_COLUMNS: TableColumnSpec[] = [
  { key: "studentDob", width: 64, align: "center", title: "DOB" },
  { key: "studentName", width: 200 },
  { key: "missedClassGroup", width: 110, title: "Group" },
  { key: "skillLevels", width: 100, title: "Level" },
  { key: "reason", width: 130 },
  { key: "missedClassName", width: 200 },
  { key: "missedClassSessionDate", width: 120 },
  { key: "makeupClassName", width: 200 },
  { key: "makeupClassSessionDate", width: 120 },
  { key: "semester", width: 110 },
  { key: "lastUpdatedAt", width: 140, title: "Last Updated" },
]

export const MAKEUP_SEARCHABLE_FIELDS: (keyof MakeupForTable)[] = [
  "studentName",
  "studentNameAndDob",
  "studentDob",
  "missedClassName",
  "makeupClassName",
] as const

export const MAKEUP_SORTABLE_FIELDS = [
  "studentName",
  "missedClassGroup",
  "skillLevels",
  "reason",
  "missedClassName",
  "missedClassSessionDate",
  "makeupClassName",
  "makeupClassSessionDate",
  "semester",
  "lastUpdatedAt",
] as const

// Resolves the value each makeup column sorts on. Date columns display a
// formatted string but sort on the raw ISO session start; everything else
// sorts on its own (string) value. Shared by useTableSort + buildTableColumns.
export const getMakeupSortValue = (
  row: MakeupForTable,
  field: string
): string | number => {
  if (field === "missedClassSessionDate") return row.missedClassSessionDateRaw
  if (field === "makeupClassSessionDate") return row.makeupClassSessionDateRaw
  const value = row[field]
  return typeof value === "number" ? value : String(value ?? "")
}

export enum MAKEUP_REASONS {
  SICK = "SICK",
  PLANNED_ABSENCE = "PLANNED_ABSENCE",
  UNPLANNED_ABSENCE = "UNPLANNED_ABSENCE",
  VACATION = "VACATION",
  TBD = "TBD",
}

export const MAKEUP_REASON_OPTIONS = [
  { label: "Sick", value: MAKEUP_REASONS.SICK },
  { label: "Planned Absence", value: MAKEUP_REASONS.PLANNED_ABSENCE },
  { label: "Unplanned Absence", value: MAKEUP_REASONS.UNPLANNED_ABSENCE },
  { label: "Vacation", value: MAKEUP_REASONS.VACATION },
  { label: "TBD", value: MAKEUP_REASONS.TBD },
]
